var stickySidebar = (function($) {
	'use strict';

	var _nav = function() {
		var $el = $('.sticky-sidebar__sidebar ul li');

		$el.on('click touchstart', function() {
			var thisTag = $(this).data('tag');
			$el.removeClass('active');
			$(this).addClass('active');

			$('html, body').animate({
			    scrollTop: $('[data-block="'+ thisTag +'"]').offset().top - 100
			}, 500);
		});
	};

	var _sidebar = function() {
		var distance 	= $('.sticky-sidebar__sidebar ul').offset().top;
		var bottom 		= ($('.sticky-sidebar__content__bottom').offset().top - $('.sticky-sidebar__content__bottom').height()) + 25;
		var width 		= $('.sticky-sidebar__sidebar').width();
		var	height		= $('.sticky-sidebar__sidebar ul').height();
		var $window 	= $(window);

		$window.scroll(function() {
			if ( $window.scrollTop() >= bottom ) {
				$('.sticky-sidebar__sidebar ul').removeClass('fixed').addClass('absolute').css('width', width+'px');
			} else if ( $window.scrollTop()+height >= bottom ) {
				$('.sticky-sidebar__sidebar ul').removeClass('fixed').addClass('absolute').css('width', width+'px');
			} else if ( $window.scrollTop() >= (distance - 100) ) {
				$('.sticky-sidebar__sidebar ul').removeClass('absolute').addClass('fixed').css('width', width+'px');
			} else {
				$('.sticky-sidebar__sidebar ul').removeClass('fixed absolute').css('width', 'auto');
			}
		});

		$('.sticky-sidebar__content__block').each(function(index, el) {

			$(el).waypoint(function(direction) {
			  if (direction === 'down') {
		    	var target = $(this.element).attr('data-block');
		    	$('.sticky-sidebar__sidebar ul li').removeClass('active');
		    	$('.sticky-sidebar__sidebar ul [data-tag="'+target+'"]').addClass('active');
			  }
			}, {
			  offset: 110
			});

			$(el).waypoint(function(direction) {
			  if (direction === 'up') {
		    	var target = $(this.element).attr('data-block');
		    	$('.sticky-sidebar__sidebar ul li').removeClass('active');
		    	if ($('.sticky-sidebar__sidebar ul [data-tag="'+target+'"]').is( ":first-child" ) ) {
		    		$('.sticky-sidebar__sidebar ul [data-tag="'+target+'"]').addClass('active');
		    	} else {
		    		$('.sticky-sidebar__sidebar ul [data-tag="'+target+'"]').prev().addClass('active');
		    	}
			  }
			}, {
			  offset: 90
			});
		});
	};

	function init() {
		setTimeout(function() {
			_sidebar();
		}, 1000);

		_nav();
	}

	return {
		init:init
	};
}(jQuery));

jQuery(document).ready(function($) {
	if ($('.sticky-sidebar').length) {
		stickySidebar.init();
	}
});
